import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      enabledFeatures: state => state.dashboard.enabledFeatures
    }),
    getSubOrgTabLabel () {
      return this.getLabelFor('Employer Settings', 'Sub Organization tab', this.$t('schools'))
    },
    getSubOrgLabel () {
      return this.getLabelFor('Employer Settings', 'Sub Organization Label', this.$t('school'))
    }
  },
  methods: {
    getLabelFor (featureTitle, flagTitle, defaultLabel) {
      let feature = this.enabledFeatures && this.enabledFeatures[featureTitle]
      if (feature && feature.enabled) {
        let flags = feature.flags || []
        for (let i = 0; i < flags.length; i++) {
          let flag = flags[i]
          if (flag.title === flagTitle && flag.label) {
            return flag.label
          }
        }
      }
      return defaultLabel
    },
    isFlagEnabled (featureTitle, flagTitle) {
      let feature = this.enabledFeatures && this.enabledFeatures[featureTitle]
      if (feature && feature.enabled) {
        let flags = feature.flags || []
        for (let i = 0; i < flags.length; i++) {
          let flag = flags[i]
          if (flag.title === flagTitle) {
            return flag.enabled
          }
        }
      }
      return false
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/employer/employerSettingsFlags.js